import axios from '../utils/axiosInstance';

const buildAudienceFormData = (
  jmailsPayload,
  excelFile = null,
  omitirErrores = false,
  excluirFilas = []
) => {
  const formData = new FormData();
  if (excelFile) formData.append('data', excelFile);
  formData.append('jmails', JSON.stringify(jmailsPayload));
  // Sin esto el backend devuelve 409 y no carga nada cuando hay filas con error:
  // omitir gente tiene que ser una decisión de quien carga, no un descuido.
  if (omitirErrores) formData.append('omitirErrores', 'true');
  // Filas del Excel que el operador descartó en la revisión: el backend no las carga.
  if (excluirFilas?.length) formData.append('excluirFilas', excluirFilas.join(','));
  return formData;
};

/**
 * Revisa el archivo sin cargar nada. Devuelve el mismo reporte que la carga, pero
 * no toca la base: responde en segundos aunque el archivo traiga 20.000 filas.
 * Sirve para que el operador vea los errores antes de que algo quede escrito.
 */
export const validateAudienceAPI = async (jmailsPayload, excelFile = null) => {
  const response = await axios.post(
    'journey/audience/validate',
    buildAudienceFormData(jmailsPayload, excelFile)
  );
  return response;
};

export const sendInvitationAPI = async (
  jmailsPayload,
  excelFile = null,
  omitirErrores = false,
  excluirFilas = []
) => {
  const response = await axios.post(
    'journey/audience',
    buildAudienceFormData(jmailsPayload, excelFile, omitirErrores, excluirFilas)
  );
  return response;
};

export const dispatchJourneyMailAPI = async (payload) => {
  const response = await axios.post('journey/dispatch', payload);
  return response;
};

export const dispatchSingleAnswerMailAPI = async (answerId, payload) => {
  const response = await axios.post(`journey/dispatch/answer/${answerId}`, payload);
  return response;
};
